// extracted by mini-css-extract-plugin
export default {"submenu":"Submenu_submenu__2eIN4","hover":"Submenu_hover__V6OBV","noIcon":"Submenu_noIcon__YcuKZ","title":"Submenu_title__a8Mr9","icon":"Submenu_icon__Jg5Ro"};